
import explore1 from "../../Assets/explore1.png";
import explore2 from "../../Assets/explore2.png";
import explore3 from "../../Assets/explore3.png";
import explore4 from "../../Assets/explore4.png";
import explore5 from "../../Assets/explore5.png";
import personalcare1 from "../../Assets/personalcare1.png"
import personalcare2 from "../../Assets/personalcare2.png"
import personalcare3 from "../../Assets/personalcare3.png"
import personalcare4 from "../../Assets/personalcare4.png"
import medical1 from "../../Assets/medical1.png"
import medical2 from "../../Assets/medical2.png"
import medical3 from "../../Assets/medical3.png"
import medical4 from "../../Assets/medical4.png"
import medical5 from "../../Assets/medical5.png"
import medical6 from "../../Assets/medical6.png"
import bed1 from "../../Assets/bed1.png"
import bed2 from "../../Assets/bed2.png"
import bed3 from "../../Assets/bed3.png"
import bed4 from "../../Assets/bed4.png"
import bed5 from "../../Assets/bed5.png"
import post1 from "../../Assets/post1.png"
import post2 from "../../Assets/post2.png"
import post3 from "../../Assets/post3.png"
import post4 from "../../Assets/post4.png"
import post5 from "../../Assets/post5.png"
import count1 from "../../Assets/count1.png"
import count2 from "../../Assets/count2.png"
import count3 from "../../Assets/count3.png"
import count4 from "../../Assets/count4.png"
import mansi from "../../Assets/mansi.png"
import vinod from "../../Assets/vinod.png"
import harshita from "../../Assets/harshita.png"
import heartfelt from "../../Assets/heartfelt.png";
 

export const serviceShowcaseData = [
    {
        imgSrc: heartfelt,
        title: `Heartfelt Care \n Everyday`,
        buttonText: "Book Now",
        onButtonClick: () => console.log("Button Clicked"),
    }
]


export const medicalCareOptions = {
    Assessment: { title: "Assessment", img: medical1 },
    MonitoringVitals: { title: "Monitoring Vitals", img: medical2 },
    WoundCare: { title: "Wound Care", img: medical3 },
    MedicineAdministration: { title: "Medicine Administration", img: medical4 },
    PrescriptionRefills: { title: "Prescription Refills", img: medical5 },
    MobilityAssist: { title: "Mobility Assist", img: medical6 },
};
export const careOptions = {
    heading: "Explore Our Care",
    subheading: `Elderly Care`,
    services: [
        { title: "Companionship", img: explore1 },
        { title: "Leisure Activities", img: explore2 },
        { title: "Feeding", img: explore3 },
        { title: "Emotional Support", img: explore4 },
        { title: "Prevent Falls", img: explore5 },
    ]
};

export const personalCareOptions = {
    heading: "Personal Care",
    services: [
        { title: "Bathing", img: personalcare1 },
        { title: "Dressing", img: personalcare2 },
        { title: "Grooming", img: personalcare3 },
        { title: "Feeding", img: personalcare4 },
        { title: "Toileting", img: bed4 },
    ]
};

export const bedCareOptions = {
    heading: `BedSide Care`,
    services: [
        { title: "Mobility Assist", img: bed1 },
        { title: "Feeding", img: bed2 },
        { title: "Personal Hygiene", img: bed3 },
        { title: "Toileting", img: bed4 },
        { title: "Prevent Bed Sores", img: bed5 },
    ]
};

export const postOperativeCare = {
    heading: "Post Operative Care",
    services: [
        { title: "Vitals Monitoring", img: post1 },
        { title: "Mobility Assist", img: post2 },
        { title: "Medication Management", img: post3 },
        { title: "Nutritional Support", img: post4 },
        { title: "Safety & Comfort", img: post5 },
    ],
};


export const countOn = {
    VastExpertise: { title: "Vast Expertise", img: count1 },
    Verification: { title: "Background Check & Verification", img: count2 },
    Individualized: { title: "Individualized Care", img: count3 },
    Continuity: { title: "Continuity Of Care", img: count4 },
};

export const testimonialstitle = ``;

export const testimonialData = [

    {
        title: `Where Words Fail, Care Speaks`,
        desc: "Choosing Wihan Caregiver Service was the best decision we made for my husband's post-operative care. The caregivers were always punctual, professional, and caring. They made sure he was comfortable and well-cared for throughout his recovery",
        userimg: mansi,
        username: "Mansi"

    },
    {
        title: `Where Words Fail, Care Speaks`,
        desc: `After my surgery, I was worried about how I would manage at home. But
thanks to the wonderful caregivers from Arush, I felt supported every
step of the way. Their kindness and professionalism made my recovery
so much easier.`,
        userimg: vinod,
        username: "Vinod",
    },
    {
        title: `Where Words Fail, Care Speaks`,
        desc: `I was hesitant at first about having a nurse at home, but the team from Arush exceeded all my expectations. They were attentive, respectful, and always made sure I was comfortable. It truly felt like having a family member by my side.`,
        userimg: harshita,
        username: "Priya",
    },
];


export const truncateLetters = (str, num) => {
    return str.length > num ? str.slice(0, num) + "..." : str;
};

export const settings = {
    dots: true,
    infinite: true,
    speed: 600,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    pauseOnHover: true,

    responsive: [
        { breakpoint: 1024, settings: { slidesToShow: 3 } },
        { breakpoint: 768, settings: { slidesToShow: 2 } },
        { breakpoint: 480, settings: { slidesToShow: 1 } },
    ],

    appendDots: dots => (
        <ul>
            {dots.slice(0, 3)}
        </ul>
    ),
    customPaging: i => (
        <button>{i + 1}</button>
    )
};

export const settings2 = {
    dots: true,
    infinite: true,
    speed: 600,
    slidesToShow: 2,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 4000,
    pauseOnHover: true,
    responsive: [
        { breakpoint: 1024, settings: { slidesToShow: 2 } },
        { breakpoint: 768, settings: { slidesToShow: 1 } },
    ],
};

export const caregiverexpert_p = ` At Wihan, we believe that compassion is the cornerstone of quality care. Our dedicated caregivers embody this philosophy, providing \n unparalleled support with empathy, understanding, and genuine kindness. Just as fashion trends come and go, the need for compassion \n remains constant, and our caregivers strive to ensure that every individual we serve feels valued, respected, and cared for.`

export const exploreourh2 = `Explore Our Care`
export const exploreourh4 = `Elderly Care`
export const h2div = {
    heading2: "Caregivers Are The New Superheroes",
    p: `Our team of caregivers embodies this spirit of heroism, providing \n compassionate care to our clients with unwavering dedication and \n commitment. Just like superheroes, they are there in times of crisis,\n offering strength, reassurance, and a helping hand. Whether it's \n assisting with daily activities, providing medical support, or simply \n offering a listening ear, our caregivers are the unsung heroes \n of our community.`
}
export const personalcareh2 = `Personal Care`
export const medicalcareh2 = `Medical Care`
export const bedsideh2 = `Bed Side Care`
export const postoperativeh2 = `Post Operative Care`
export const countonh2 = `Caregivers You Can Count On`